import * as React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { WebhookFormView } from '../WebhookEditForm/view';
import { WEBHOOK_CREATE } from 'const/mutations';
import { APP_QUERY } from 'const/queries';
import { useMemo } from 'react';

export function WebhookCreateForm() {
    const navigate = useNavigate();
    const { id: appId } = useParams<{ id: string }>();

    const { data } = useQuery(APP_QUERY, { variables: { id: appId } });
    const app = data && data.app;

    const webhook = useMemo(
        () => ({
            appId: appId,
            topic: '',
            url: '',
        }),
        [appId]
    );

    const [webhookCreate, { loading }] = useMutation(WEBHOOK_CREATE, {
        onCompleted() {
            navigate('/extranet/apps/' + appId + '/dashboard');
        },
    });

    const onSubmit = (values, form, callback) => {
        values.appId = appId;
        webhookCreate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const onCancel = () => {
        navigate('/extranet/apps/' + appId + '/dashboard');
    };

    return (
        <WebhookFormView
            app={app}
            webhook={webhook}
            loading={loading}
            onCancel={onCancel}
            onSubmit={onSubmit}
        />
    );
}
